var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35;
const _excluded = ["svgRef"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgCjt = _ref => {
  let {
      svgRef
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 89,
    viewBox: "0 0 78 89",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.675 50.05C73.675 31.1617 58.3633 15.85 39.475 15.85C20.5867 15.85 5.27502 31.1617 5.27502 50.05C5.27502 68.9383 20.5867 84.25 39.475 84.25C58.3633 84.25 73.675 68.9383 73.675 50.05Z",
    fill: "#D0EEFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.725 50.05C77.725 28.9252 60.5998 11.8 39.475 11.8C18.3502 11.8 1.22498 28.9252 1.22498 50.05C1.22498 71.1748 18.3502 88.3 39.475 88.3C60.5998 88.3 77.725 71.1748 77.725 50.05Z",
    stroke: "#A4B8D0",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "0.91 4.55"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.525 45.775C61.525 31.2364 49.7386 19.45 35.2 19.45C20.6614 19.45 8.875 31.2364 8.875 45.775C8.875 60.3136 20.6614 72.1 35.2 72.1C49.7386 72.1 61.525 60.3136 61.525 45.775Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6604 25.4872H42.0699",
    stroke: "white",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6604 37.1235H35.5242",
    stroke: "white",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.8822 44.904L46.0188 51.7674C45.7029 52.0833 45.1908 52.0833 44.8749 51.7674L41.6475 48.5409C41.3316 48.2241 40.8195 48.2241 40.5036 48.5409L37.5327 51.5109C37.2177 51.8259 37.2168 52.338 37.5327 52.6548L44.0379 59.1717C44.8119 59.9466 46.0674 59.9466 46.8423 59.1726L56.9961 49.0179C57.312 48.702 57.312 48.1899 56.9961 47.874L54.0261 44.904C53.7102 44.5881 53.1981 44.5881 52.8822 44.904Z",
    stroke: "white",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M8.36475 19.1604H15.3055C15.8905 19.1604 16.3648 18.6861 16.3648 18.1011V15.5244",
    stroke: "white",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6604 31.3056H42.0699",
    stroke: "white",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M53.0128 40.0379V11.5016C53.0128 9.06714 51.0319 7.08624 48.5983 7.08624H37.3645",
    stroke: "white",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3643 7.08597H8.13142C5.69692 7.08597 3.71692 9.06687 3.71692 11.5014V20.1927V66.8649C3.71692 70.4964 6.67072 73.4502 10.3013 73.4502H46.4282C50.0588 73.4502 53.0126 70.4964 53.0126 66.8649V58.9368",
    stroke: "white",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M48.922 62.8754V66.8651C48.922 68.2421 47.806 69.359 46.4281 69.359H10.3012C8.92415 69.359 7.80725 68.2421 7.80725 66.8651V20.1929C7.80725 19.5314 8.07005 18.8978 8.53805 18.4298L15.0604 11.9075C15.5284 11.4404 16.1629 11.1776 16.8235 11.1776H19.3642",
    stroke: "white",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M37.3647 11.1773H48.5976C48.7767 11.1773 48.9216 11.3222 48.9216 11.5013V42.7376",
    stroke: "white",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1149 46.1872H31.2695",
    stroke: "white",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6604 46.1872H15.9897",
    stroke: "white",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M20.114 57.8235H31.0247",
    stroke: "white",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6604 57.8235H15.7647",
    stroke: "white",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1901 52.0056H31.27",
    stroke: "white",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6604 52.0056H15.69",
    stroke: "white",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.5919 4.31345H32.4554V3.66545C32.4554 2.44235 31.4636 1.44965 30.2396 1.44965H26.4848C25.2635 1.44965 24.2735 2.43965 24.2735 3.66095V4.31345H21.137C20.1623 4.31345 19.3649 5.11175 19.3649 6.08645V11.5404C19.3649 12.516 20.1623 13.3134 21.137 13.3134H35.5919C36.5666 13.3134 37.3649 12.516 37.3649 11.5404V6.08645C37.3649 5.11175 36.5666 4.31345 35.5919 4.31345Z",
    stroke: "white",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M24.683 9.22258H32.0468",
    stroke: "white",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2103 25.0372H41.6198",
    stroke: "#0F4C82",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2103 36.6735H35.0741",
    stroke: "#0F4C82",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.4323 44.454L45.5689 51.3174C45.253 51.6333 44.7409 51.6333 44.425 51.3174L41.1976 48.0909C40.8817 47.7741 40.3696 47.7741 40.0537 48.0909L37.0828 51.0609C36.7678 51.3759 36.7669 51.888 37.0828 52.2048L43.588 58.7217C44.362 59.4966 45.6175 59.4966 46.3924 58.7226L56.5462 48.5679C56.8621 48.252 56.8621 47.7399 56.5462 47.424L53.5762 44.454C53.2603 44.1381 52.7482 44.1381 52.4323 44.454Z",
    stroke: "#FF4502",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M7.91479 18.7104H14.8556C15.4406 18.7104 15.9149 18.2361 15.9149 17.6511V15.0744",
    stroke: "#0F4C82",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2103 30.8556H41.6198",
    stroke: "#0F4C82",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M52.5627 39.5879V11.0516C52.5627 8.61713 50.5818 6.63623 48.1482 6.63623H36.9144",
    stroke: "#0F4C82",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9142 6.63599H7.68135C5.24775 6.63599 3.26685 8.61689 3.26685 11.0514V19.7427V66.4149C3.26685 70.0464 6.22065 73.0002 9.85125 73.0002H45.9781C49.6087 73.0002 52.5625 70.0464 52.5625 66.4149V58.4868",
    stroke: "#0F4C82",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M48.4719 62.4254V66.4151C48.4719 67.7921 47.3559 68.909 45.978 68.909H9.85108C8.47408 68.909 7.35718 67.7921 7.35718 66.4151V19.7429C7.35718 19.0814 7.61998 18.4478 8.08798 17.9798L14.6103 11.4575C15.0783 10.9904 15.7128 10.7276 16.3734 10.7276H18.9141",
    stroke: "#0F4C82",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M36.9148 10.7273H48.1477C48.3268 10.7273 48.4717 10.8722 48.4717 11.0513V42.2876",
    stroke: "#0F4C82",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6649 45.7372H30.8195",
    stroke: "#0F4C82",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2103 45.7372H15.5396",
    stroke: "#FF4502",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6639 57.3735H30.5746",
    stroke: "#0F4C82",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2103 57.3735H15.3146",
    stroke: "#FF4502",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M19.74 51.5556H30.8199",
    stroke: "#0F4C82",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2103 51.5556H15.2399",
    stroke: "#FF4502",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.1419 3.86343H32.0054V3.21543C32.0054 1.99233 31.0136 0.999634 29.7896 0.999634H26.0348C24.8135 0.999634 23.8235 1.98963 23.8235 3.21093V3.86343H20.687C19.7123 3.86343 18.9149 4.66173 18.9149 5.63643V11.0904C18.9149 12.066 19.7123 12.8634 20.687 12.8634H35.1419C36.1166 12.8634 36.9149 12.066 36.9149 11.0904V5.63643C36.9149 4.66173 36.1166 3.86343 35.1419 3.86343Z",
    stroke: "#FF4502",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M24.233 8.77257H31.5968",
    stroke: "#FF4502",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCjt, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/cjt.f44325ca.svg";
export { ForwardRef as ReactComponent };